import { LOAD_MORE_SIZE } from 'common_constants/Ideas'

// Ideas requested per ideaList call. Only admins get real pages from the backend; other
// users always receive the full list in one response.
export const IDEA_LIST_PAGE_SIZE = LOAD_MORE_SIZE

// `value` must match the backend STATUS_MAP keys of ideaList (InnovateIdeaManager).
// Unknown keys are ignored by the backend, so a typo silently returns unfiltered data.
export const IDEA_STATUS_OPTIONS = [
  { value: 'Selected_For_Hackathon', label: 'Selected for Hackathon' },
  { value: 'Active', label: 'Active' },
  { value: 'Evaluating', label: 'Evaluating' },
  { value: 'Investigating', label: 'Investigating' },
  { value: 'Incubating', label: 'Incubating' },
  { value: 'Implementing', label: 'Implementing' },
  { value: 'Implemented', label: 'Implemented' },
  { value: 'Implemented_PIR', label: 'Implemented PIR' },
  { value: 'Backlog', label: 'Backlog' },
  { value: 'No_Apetite', label: 'No Appetite' },
  { value: 'Not_New', label: 'Not New' },
  { value: 'Idea_Closed', label: 'Idea Closed' },
]

// Filters that are sent to the API. Search is applied client-side and is not part of this.
export const EMPTY_IDEA_FILTERS = Object.freeze({ statuses: [] })